var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86482 8.69117C9.90784 8.73419 9.94196 8.78525 9.96524 8.84145C9.98851 8.89766 10.0005 8.95789 10.0005 9.01872C10.0005 9.07955 9.98851 9.13979 9.96524 9.19599C9.94196 9.25219 9.90784 9.30325 9.86482 9.34627C9.82181 9.38928 9.77074 9.4234 9.71454 9.44668C9.65834 9.46996 9.59811 9.48194 9.53728 9.48194C9.47645 9.48194 9.41621 9.46996 9.36001 9.44668C9.30381 9.4234 9.25274 9.38928 9.20973 9.34627L5.37061 5.50657L1.53149 9.34627C1.44462 9.43314 1.3268 9.48194 1.20394 9.48194C1.08109 9.48194 0.963267 9.43314 0.876397 9.34627C0.789526 9.2594 0.740723 9.14158 0.740723 9.01872C0.740723 8.89587 0.789526 8.77805 0.876397 8.69117L4.7161 4.85205L0.876397 1.01293C0.789526 0.926064 0.740723 0.808242 0.740723 0.685388C0.740723 0.562535 0.789526 0.444713 0.876397 0.357842C0.963267 0.270971 1.08109 0.222168 1.20394 0.222168C1.3268 0.222168 1.44462 0.270971 1.53149 0.357842L5.37061 4.19754L9.20973 0.357842C9.2966 0.270971 9.41442 0.222168 9.53728 0.222168C9.66013 0.222168 9.77795 0.270971 9.86482 0.357842C9.95169 0.444713 10.0005 0.562535 10.0005 0.685388C10.0005 0.808242 9.95169 0.926064 9.86482 1.01293L6.02512 4.85205L9.86482 8.69117Z",
    fill: "#C44744",
    stroke: "#C44744",
    strokeWidth: 0.37037
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEdit);
export default __webpack_public_path__ + "static/media/closeEdit.02cc4c59a13c093a5bbc2bd05b3204f5.svg";
export { ForwardRef as ReactComponent };